<template>
  <section class="section-checkout">
    <hr v-if="hasDivider">
    <label class="mb-0">{{ $t('message.booking.summary.discount_and_coins') }}</label>
    <promo-code v-if="user" :creditDiscountCost="creditDiscountCost" :totalPrice="totalPrice"/>
    <hr>
    <label>{{ $t('message.my_reservations.payment_detail') }}</label>
    <div class="d-flex mb-1">
      <div class="p-0">
        {{ $t('message.booking.summary.subtotal') }}
      </div>
      <div class="flex-fill p-0 text-right">
        {{ subtotal | currency }}
      </div>
    </div>
    <div class="d-flex mb-1" v-if="appliedPromoCode && appliedPromoCode.is_applied">
      <div class="p-0">
        {{ $t('message.promo_code.discount') }}
      </div>
      <div class="flex-fill p-0 text-right -status-discount">
        -{{ discountCost | currency }}
      </div>
    </div>
    <div class="d-flex mb-1">
      <div class="p-0">{{ $t('message.booking.summary.vat') }}</div>
      <div class="flex-fill p-0 text-right">
        {{ serviceVat | currency }}
      </div>
    </div>
    <section v-if="(preCheckoutData && preCheckoutData.is_credit) && creditDiscountCost">
      <div class="d-flex mb-1">
        <div class="p-0">{{ $t('message.booking.summary.coins_discount') }}</div>
        <div class="flex-fill p-0 text-right -status-discount">
          -{{ creditDiscountCost | currency }}
        </div>
      </div>
      <div class="d-flex pt-2 text-total-price">
        <div class="p-0"><label class="mb-0">{{ $t('message.booking.summary.total_price') }}</label></div>
        <div class="flex-fill p-0 text-right">
          <div class="text-primary">
            <label class="mb-0">{{ totalPrice | currency }}</label>
          </div>
        </div>
      </div>
    </section>
    <div class="d-flex pt-2 text-total-price" v-else>
      <div class="p-0"><label class="mb-0">{{ $t('message.booking.summary.total_price') }}</label></div>
      <div class="flex-fill p-0 text-right">
        <div class="text-primary">
          <label class="mb-0">{{ totalPrice | currency }}</label>
        </div>
      </div>
    </div>
    <div class="d-flex pt-2 text-total-price" v-else>
      <div class="p-0"><label class="mb-0">{{ $t('message.booking.summary.total_price') }}</label></div>
      <div class="flex-fill p-0 text-right">
        <div class="text-primary">
          <label class="mb-0">{{ totalPrice | currency }}</label>
        </div>
      </div>
    </div>
    <promo-code-detail-modal ref="promoCodeDetailModal"></promo-code-detail-modal>
    <snackbar ref="snackbar"
              baseSize="100px"
              :colors="{open: '#333', info: '#3DBD7D', error: '#FA7377', warn: '#FF6600'}"
              :holdTime="2500"
              :position="'bottom-center'"/>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { checkoutCostMixin } from '../../../mixins/checkoutCostMixin'
  import PromoCode from '../components/PromoCode'
  import PromoCodeDetailModal from '../components/PromoCodeDetailModal'

  export default {
    mixins: [checkoutCostMixin],
    props: {
      hasDivider: {
        type: Boolean,
        default: true
      }
    },
    components: {
      PromoCode,
      PromoCodeDetailModal
    },
    computed: {
      ...mapGetters({
        appliedPromoCode: 'promoCode/getAppliedPromoCode',
        preBookingData: 'booking/getPreBookingData',
        user: 'auth/getUser'
      })
    },
    watch: {
      totalPrice () {
        const costData = {
          totalPrice: this.totalPrice,
          discountCost: this.discountCost,
          creditDiscountCost: this.creditDiscountCost
        }
        this.$emit('onChangedCostData', costData)
      }
    },
    methods: {
      displaySnackbar (message) {
        this.$refs.snackbar.open(message)
      },
      displayPromoCodeDetailDialog () {
        this.$refs.promoCodeDetailModal.showModal(true)
      },
      displayCancelPromoCodeDialog () {
        this.$swal({
          text: this.$i18n.t('message.alert.cancel_promo_code'),
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonColor: '#17a2b8',
          confirmButtonText: this.$i18n.t('message.button.cancel_current_promo_code'),
          cancelButtonText: this.$i18n.t('message.button.use_current_promo_code')
        }).then((result) => {
          if (result) {
            this.displaySnackbar(this.$i18n.t('message.promo_code.cancel_current_promo_code_alert'))
            this.$store.commit('promoCode/SET_APPLIED_PROMO_CODE', null)
          }
        })
      }
    }
  }
</script>

<style



// WEBPACK FOOTER //
// src/components/booking/components/CheckoutCost.vue